module.exports = __webpack_public_path__ + "img/banner_01.e5b2baee.png";